import { useEffect, useState } from "react";
import { getValidSpotifyToken } from "../utils/spotify-auth";

const FROM_ZERO_TRACK_IDS = [
  "spotify:track:2PnlsTsOTLE5jnBnNe2K0A", // The Emptiness Machine
  "spotify:track:3fgehc497TFqKH1zBL2YNK", // Heavy Is the Crown
  "spotify:track:3t4IkHfT4eXZggkupi4SUe", // Over Each Other
];

export function useSpotifyPlayer() {
    const [currentlyPlaying, setCurrentlyPlaying] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isPlayingFromZero, setIsPlayingFromZero] = useState(false);
  
    useEffect(() => {

      const checkIfFromZeroSong = (track) => {
        if (!track) return false;
        return FROM_ZERO_TRACK_IDS.includes(track.uri);
      };
  
      const checkPlaying = async () => {
        try {
          const token = await getValidSpotifyToken();
          const response = await fetch('https://api.spotify.com/v1/me/player/currently-playing?market=from_token', {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          
          if (response.status === 204) {
            setCurrentlyPlaying(null);
            setIsPlaying(false);
            setIsPlayingFromZero(false);
            return;
          }
  
          if (response.ok) {
            const data = await response.json();
            const isFromZero = checkIfFromZeroSong(data.item);
            
            setCurrentlyPlaying(data);
            setIsPlaying(data.is_playing);
            setIsPlayingFromZero(isFromZero);
          }
        } catch (error) {
          console.error('Error checking current track:', error);
        }
      };
      
      checkPlaying();
      const interval = setInterval(checkPlaying, 5000);
      return () => clearInterval(interval);
    },);
  
    return { currentlyPlaying, isPlaying, isPlayingFromZero };
}